import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import IconButton from "@khanacademy/wonder-blocks-icon-button";
import {
    border,
    color,
    semanticColor,
    spacing,
} from "@khanacademy/wonder-blocks-tokens";

import {controlsCardDimensions} from "./card-sizing.ts";
import {CONTROLS_HEIGHT} from "./constants.ts";

import thumbsDownIcon from "@phosphor-icons/core/bold/thumbs-down-bold.svg";
import thumbsUpIcon from "@phosphor-icons/core/bold/thumbs-up-bold.svg";

interface ControlsCardProps {
    cardWidth: number;
    cardHeight: number;
    discardTop: () => void;
    keepTop: () => void;
    disabled: boolean;
}

const ControlsCard: React.FC<ControlsCardProps> = (props) => {
    const cardDimensions = {
        width: props.cardWidth,
        height: props.cardHeight,
    };
    const dimensions = controlsCardDimensions(
        props.cardWidth,
        props.cardHeight,
    );
    const offsets = {
        bottom: 0,
        right: 0,
    };

    return (
        <View style={[styles.controlsCard, dimensions, offsets]}>
            <View style={cardDimensions} />
            <DeckControls
                discardTop={props.discardTop}
                keepTop={props.keepTop}
                disabled={props.disabled}
            />
        </View>
    );
};

interface DeckControlsProps {
    discardTop: () => void;
    keepTop: () => void;
    disabled: boolean;
}

function DeckControls(props: DeckControlsProps): React.ReactNode {
    return (
        <View style={styles.controls}>
            <View style={styles.draftActions}>
                <IconButton
                    style={[styles.button, styles.leftButton]}
                    kind="tertiary"
                    icon={thumbsDownIcon}
                    onClick={props.discardTop}
                    size="medium"
                    disabled={props.disabled}
                />
                <IconButton
                    style={[styles.button, styles.rightButton]}
                    kind="tertiary"
                    icon={thumbsUpIcon}
                    onClick={props.keepTop}
                    size="medium"
                    disabled={props.disabled}
                />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    controls: {
        position: "static",
        height: CONTROLS_HEIGHT,
        padding: spacing.xxxxSmall_2,
        width: "100%",
    },
    controlsCard: {
        position: "absolute",
        display: "flex",
        backgroundColor: semanticColor.status.neutral.background,
        flexDirection: "column",
        borderStyle: "solid",
        borderWidth: border.width.thin,
        borderColor: semanticColor.border.primary,
        borderRadius: border.radius.radius_040,
    },
    draftActions: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
    },
    button: {
        width: "50%",
        height: 56,
        marginBlockEnd: spacing.xSmall_8,
        marginBlockStart: spacing.xSmall_8,
        color: color.blue,
        borderWidth: "thin",
        borderStyle: "solid",
        borderColor: semanticColor.border.primary,
        backgroundColor: semanticColor.surface.primary,
    },
    leftButton: {
        borderRadius: border.radius.radius_0,
        borderEndStartRadius: border.radius.radius_040,
        marginInlineStart: spacing.xSmall_8,
        marginInlineEnd: spacing.xxxSmall_4,
    },
    rightButton: {
        borderRadius: 0,
        borderEndEndRadius: border.radius.radius_040,
        marginInlineEnd: spacing.xSmall_8,
        marginInlineStart: spacing.xxxSmall_4,
    },
});

export default ControlsCard;
